import { RouteConfig } from 'vue-router'

const Index = () => import('../activity/fifa-world-cup/2026/Index.vue')
const LotteryRewards = () => import('../activity/fifa-world-cup/2026/LotteryRewards.vue')

export const index: RouteConfig = {
  path: '/activity/fifa-world-cup/2026',
  name: 'fifa_world_cup_2026',
  component: Index,
  props: (_route) => ({ ..._route.query, ..._route.params }),
  meta: {
    title: '足球世界杯',
  },
}

export const lotteryRewardsRoute: RouteConfig = {
  path: '/activity/fifa-world-cup/2026/lottery-rewards',
  name: 'fifa_world_cup_2026_lottery_rewards',
  component: LotteryRewards,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '抽奖记录',
  },
}

export default [index, lotteryRewardsRoute]
